function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFgLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.53 144.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SALES"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.69 33.01 96.67 60.71 96.67 116.12 48.69 143.82 0.7 116.12 0.7 60.71 48.69 33.01",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,116.29l48-27.82m0,0-.12-55.41m.15,55.41,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_8",
    "data-name": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.52,130.3c.21.13.21.33,0,.45a.85.85,0,0,1-.79,0c-.21-.12-.21-.32,0-.45A.91.91,0,0,1,52.52,130.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43,130.3c.21.13.21.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,48.43,130.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.47,129.12c.22.13.22.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,50.47,129.12Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.99,
    cy: 129.35,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43,127.94c.21.13.21.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,48.43,127.94Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.32,127.93c.22.13.22.33,0,.45a.83.83,0,0,1-.78,0c-.22-.12-.22-.32,0-.45A.89.89,0,0,1,44.32,127.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.37,126.75c.21.13.21.33,0,.45a.85.85,0,0,1-.79,0c-.21-.12-.21-.32,0-.45A.91.91,0,0,1,46.37,126.75Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.89,
    cy: 126.98,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.32,125.57a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,44.32,125.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,125.57a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,40.23,125.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.28,124.39a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,42.28,124.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.19,124.39a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.89.89,0,0,1,38.19,124.39Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.84,
    cy: 123.44,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15,123.21a.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0,.24.24,0,0,1,0-.45A.91.91,0,0,1,36.15,123.21Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.19,122a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,38.19,122Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.71,
    cy: 122.26,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.15,120.85a.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0,.24.24,0,0,1,0-.45A.85.85,0,0,1,36.15,120.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.06,120.85a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,32.06,120.85Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1,119.67a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,34.1,119.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,119.67a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,30,119.67Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.06,118.49a.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,32.06,118.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,117.3c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,30,117.3Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.78,129.14a.86.86,0,0,1,.78,0,.24.24,0,0,1,0,.45.85.85,0,0,1-.79,0A.24.24,0,0,1,53.78,129.14Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,128a.24.24,0,0,1,0,.45.89.89,0,0,1-.78,0,.24.24,0,0,1,0-.45A.83.83,0,0,1,56.61,128Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66,127.23a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45a.85.85,0,0,1,.79,0c.21.12.21.32,0,.45Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,125.6c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,60.7,125.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.74,124.42c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,62.74,124.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,123.24c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,64.79,123.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,122.06c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,66.83,122.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.88,120.88c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,68.88,120.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.74,128a.83.83,0,0,1,.78,0,.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0A.24.24,0,0,1,51.74,128Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,126.78c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,54.57,126.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,125.6c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,56.61,125.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66,124.42c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,58.66,124.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,123.24c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,60.7,123.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.74,122.06c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,62.74,122.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,120.88c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,64.79,120.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,119.7c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,66.83,119.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.49,
    cy: 118.74,
    rx: 0.55,
    ry: 0.32,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.69,126.78a.85.85,0,0,1,.79,0,.24.24,0,0,1,0,.45.83.83,0,0,1-.78,0A.24.24,0,0,1,49.69,126.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.52,125.6c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,52.52,125.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.57,124.42c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,54.57,124.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,123.24c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,56.61,123.24Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.66,122.06c.21.12.21.32,0,.45a.91.91,0,0,1-.79,0c-.21-.13-.21-.33,0-.45A.85.85,0,0,1,58.66,122.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7,120.88c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,60.7,120.88Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.74,119.7c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.21-.13-.21-.33,0-.45A.83.83,0,0,1,62.74,119.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.79,118.52c.21.12.21.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,64.79,118.52Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,117.34c.22.12.22.32,0,.45a.89.89,0,0,1-.78,0c-.22-.13-.22-.33,0-.45A.83.83,0,0,1,66.83,117.34Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.63,125.59a.83.83,0,0,1,.78,0c.22.12.22.32,0,.45a.91.91,0,0,1-.79,0C47.42,125.91,47.42,125.71,47.63,125.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,85.72c0-.7-.85-2.19-3.1-3.49l-12-7A7.69,7.69,0,0,0,44.94,75l-4.75,2.75s-2.43,1.45-6.94,4h0c-2.64,1.49-3.94,2.94-3.94,4.18v25.9A6.59,6.59,0,0,0,32.43,117l12,6.94a7.67,7.67,0,0,0,6.9.28L63.82,117h0l.11-.06A6.42,6.42,0,0,0,67,111.5l0-25.58h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.35,125.19a8.34,8.34,0,0,1-4.06-1l-12-6.94a6.83,6.83,0,0,1-3.27-5.4V85.92c0-1.4,1.41-2.94,4.09-4.45,4.46-2.53,6.92-4,6.94-4l4.76-2.75A8,8,0,0,1,52,75l12.06,7c2.19,1.27,3.22,2.83,3.25,3.75l0,25.79a6.77,6.77,0,0,1-3.2,5.7l-12.58,7.26A6.39,6.39,0,0,1,48.35,125.19ZM47.94,74.6a5.87,5.87,0,0,0-2.84.65L40.35,78s-2.49,1.48-7,4c-2.44,1.38-3.78,2.77-3.78,3.91l0,25.9a6.34,6.34,0,0,0,2.94,4.88l12,6.94a7.38,7.38,0,0,0,6.6.28l12.58-7.26a6.15,6.15,0,0,0,2.89-5.16l0-25.77c0-.61-.84-2-2.94-3.23l-12.06-7A7.7,7.7,0,0,0,47.94,74.6Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.84,
    y: 100.25,
    width: 0.62,
    height: 20.24,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.92,75,40.17,77.7s-2.44,1.46-7,4h0a19.87,19.87,0,0,0-2,1.44c-.14.14-2.77,2.71,3,6l10.36,6a7,7,0,0,0,7.55-.16c3.54-2.09,9.47-5.53,11.48-6.69A4.36,4.36,0,0,0,65,86.89c.75-1.17,1.44-3.19-1.16-4.69l-12.06-7A7.67,7.67,0,0,0,44.92,75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,96.42a6.73,6.73,0,0,1-3.73-1.07l-10.34-6c-2.35-1.33-3.65-2.73-3.83-4.16a2.81,2.81,0,0,1,.79-2.3c.14-.1.26-.2.38-.3a14.87,14.87,0,0,1,1.67-1.18c4.46-2.53,6.92-4,6.94-4l4.76-2.75A8,8,0,0,1,52,75l12.05,7A3.71,3.71,0,0,1,66,84.17a3.87,3.87,0,0,1-.65,2.89,4.53,4.53,0,0,1-1.55,1.46c-2.89,1.67-8.21,4.77-11.48,6.69A8.1,8.1,0,0,1,48.12,96.42Zm-3-21.19L40.33,78s-2.49,1.48-6.95,4a15.13,15.13,0,0,0-1.6,1.13l-.35.28a2.13,2.13,0,0,0-.58,1.74c.15,1.2,1.37,2.48,3.52,3.69l10.36,6c.16.11,3.16,2.24,7.23-.16,3.27-1.92,8.59-5,11.48-6.69a3.9,3.9,0,0,0,1.33-1.25,3.22,3.22,0,0,0,.57-2.4,3.1,3.1,0,0,0-1.62-1.84l-12.06-7a7.34,7.34,0,0,0-6.58-.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,83.82V77.54l-4.51,0a18.3,18.3,0,0,0-13.5-.06l-4.67,0v6.48h0c.06,1.63,1.16,3.25,3.32,4.5a17.71,17.71,0,0,0,16,0c2.15-1.25,3.26-2.8,3.32-4.43v-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,90.63A16.71,16.71,0,0,1,40,88.68c-2.17-1.26-3.41-3-3.47-4.76v-6.8l4.92,0a18.8,18.8,0,0,1,13.63.07l4.76,0V84c-.06,1.81-1.26,3.43-3.48,4.71A16.7,16.7,0,0,1,48.17,90.63Zm-11-12.88v6.13c.05,1.61,1.17,3.12,3.15,4.26a17.43,17.43,0,0,0,15.73,0c2-1.17,3.11-2.61,3.17-4.17V77.85l-4.32,0a18.12,18.12,0,0,0-13.26-.06l-.06,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.19,72.8c4.43,2.56,4.43,6.71,0,9.26a17.71,17.71,0,0,1-16,0c-4.43-2.55-4.43-6.7,0-9.26A17.77,17.77,0,0,1,56.19,72.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,84.29a16.61,16.61,0,0,1-8.18-2c-2.24-1.29-3.48-3-3.48-4.9s1.24-3.6,3.48-4.9c4.51-2.6,11.84-2.6,16.35,0h0c2.24,1.3,3.48,3,3.48,4.9s-1.24,3.61-3.48,4.9A16.6,16.6,0,0,1,48.17,84.29Zm0-13.09a16.12,16.12,0,0,0-7.87,1.87c-2,1.18-3.16,2.73-3.16,4.36s1.12,3.18,3.16,4.36a17.37,17.37,0,0,0,15.73,0c2-1.18,3.17-2.72,3.17-4.36S58.07,74.25,56,73.07h0A16.11,16.11,0,0,0,48.17,71.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.89,73.73c3.71,2,3.71,5.36,0,7.4a15.48,15.48,0,0,1-13.45,0c-3.71-2-3.71-5.35,0-7.4A15.54,15.54,0,0,1,54.89,73.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.17,83a14.63,14.63,0,0,1-6.88-1.56c-1.9-1.05-2.95-2.46-2.95-4s1-2.91,2.95-4a15.88,15.88,0,0,1,13.76,0c1.9,1,2.94,2.45,2.94,4s-1,2.92-2.94,4A14.69,14.69,0,0,1,48.17,83Zm0-10.46A13.93,13.93,0,0,0,41.6,74c-1.69.93-2.62,2.15-2.62,3.43s.93,2.51,2.62,3.44a15.18,15.18,0,0,0,13.13,0c1.69-.93,2.62-2.15,2.62-3.44s-.93-2.5-2.62-3.43A13.92,13.92,0,0,0,48.17,72.5Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,79.41a8.2,8.2,0,0,0-1.17.78c.15.14.32.27.49.4a7.37,7.37,0,0,1,1-.65,13.93,13.93,0,0,1,6.57-1.5,13.92,13.92,0,0,1,6.56,1.5,8,8,0,0,1,1,.66c.18-.13.34-.26.5-.39a9.13,9.13,0,0,0-1.19-.8A15.88,15.88,0,0,0,41.28,79.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.32 80.37 44.49 78.37 46.31 78.37 46.34 72.68 42.92 73.11 40.27 74.52 38.66 77.13 38.98 78.97 40.32 80.37",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.31 83.95 49.31 90.33 53.54 89.55 57.09 87.89 58.91 85.92 59.69 84.29 59.51 78.76 57.52 81.28 55.4 82.67 50.73 83.84 49.31 83.95",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.94 83.94 46.94 90.29 44.97 90.14 44.97 83.67 46.94 83.94",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.14,123.71a3.39,3.39,0,0,1-1.83-.48c-1-.62-1.46-1.79-1.46-3.48l0-19.5c0-.08-.44-3,3.38-5.21L63.53,88a2.39,2.39,0,0,1,2.4-.31c1.19.65,1.36,2.65,1.38,3.25v20.6a6.77,6.77,0,0,1-3.2,5.7l-10.44,6,0,0A7,7,0,0,1,51.14,123.71Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.16,123.7a7.62,7.62,0,0,1-2.78-.63l-10.11-5.84a6.83,6.83,0,0,1-3.26-5.4V90.93c0-.61.18-2.62,1.38-3.27a2.38,2.38,0,0,1,2.41.31L45.07,95c3.82,2.17,3.4,5.12,3.38,5.25v19.46c0,1.68-.49,2.85-1.45,3.47A3.37,3.37,0,0,1,45.16,123.7Zm-2.49-1.19s2.5,1.14,4,.18c.77-.49,1.16-1.48,1.16-2.94V100.24c0-.15.36-2.71-3.07-4.66h0L32.47,88.51a1.83,1.83,0,0,0-1.79-.31c-.93.51-1,2.37-1.06,2.74v20.87a6.29,6.29,0,0,0,2.95,4.88l10.09,5.82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6,113.43a3,3,0,0,1-1.51-.38,4,4,0,0,1-1.69-3.67,12.16,12.16,0,0,1,5.47-9.49,3.49,3.49,0,0,1,5.71,3.3,12.11,12.11,0,0,1-5.47,9.48A5.09,5.09,0,0,1,55.6,113.43ZM60.38,99.6a4.6,4.6,0,0,0-2.27.7,11.6,11.6,0,0,0-5.24,9.08,3.53,3.53,0,0,0,1.45,3.26,3.54,3.54,0,0,0,3.55-.37,11.61,11.61,0,0,0,5.25-9.08,3.54,3.54,0,0,0-1.46-3.27A2.51,2.51,0,0,0,60.38,99.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.22,109.61v.23a.47.47,0,0,1-.22.43c-.14.08-.22,0-.22-.18v-.24c-.78.36-1.41.14-1.62-.54a.42.42,0,0,1,.24-.47l.1-.06c.16-.09.24-.06.3.08.16.36.53.46,1,.29v-2.67c-1,.19-1.47,0-1.47-1a3.5,3.5,0,0,1,1.47-2.68v-.23a.47.47,0,0,1,.22-.43c.14-.08.22,0,.22.19v.23c.62-.28,1.13-.13,1.34.37a.39.39,0,0,1-.23.47l-.13.08c-.16.09-.24.06-.31,0a.59.59,0,0,0-.67-.16v2.3c1-.18,1.71-.09,1.71,1A3.86,3.86,0,0,1,58.22,109.61Zm-.44-3.91v-2.15a2.23,2.23,0,0,0-.84,1.6C56.94,105.68,57.22,105.79,57.78,105.7Zm.44,3.21A2.51,2.51,0,0,0,59.3,107c0-.59-.3-.75-1.08-.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.49,106.26V99.21l-10.29-6v7.37c0,.92-.11,3.45-1.2,4.06l-1.87,1,10.3,6,1.6-.89C36.61,109.91,36.5,106.47,36.49,106.26Z",
    style: {
      fill: "#111"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Active",
    d: "M28.25,100.19c-.06-1.91,2.3-1,2.93,1,.62-1.27,3,.23,2.93,2.33-.06,1.51-2.63,2.68-2.92,2.8,0,0,0,0,0,0l0,0C30.87,105.88,28.31,101.76,28.25,100.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.18,106.63l-.05,0H31l-.11-.18c-.46-.73-2.87-4.64-2.93-6.24h0c0-1,.56-1.25.82-1.29a2.74,2.74,0,0,1,2.45,1.8,1.18,1.18,0,0,1,1-.17,3.08,3.08,0,0,1,2.07,3c-.06,1.57-2.4,2.73-3,3l0,.06Zm-2.67-6.46c0,1.18,1.71,4.15,2.77,5.85,1-.48,2.53-1.46,2.57-2.49a2.58,2.58,0,0,0-1.68-2.5.6.6,0,0,0-.76.29l-.29.59-.19-.62c-.4-1.27-1.49-2-2-1.88-.34.06-.4.45-.39.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.55,68.23c-2-.64-4.89.25-7.32,2.43s-3.63,5-3.2,7l-.34.3,1.05,1.16c1.71,1.91,5.6,1.22,8.69-1.55s4.21-6.56,2.5-8.47l-1-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.51,77.66c-3.14,2.81-7.11,3.5-8.86,1.54L43.52,78l.38-.33c-.4-2.12.9-4.94,3.25-7.05s5.31-3.1,7.37-2.47l.37-.33L56,69C57.77,71,56.64,74.85,53.51,77.66ZM43.86,78l1,1.07c1.66,1.86,5.48,1.16,8.52-1.56s4.15-6.44,2.49-8.3l-1-1.07-.29.26-.07,0c-2-.65-4.87.32-7.2,2.39s-3.59,4.85-3.17,6.9l0,.06Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.88,67.94c1.71,1.91.59,5.7-2.5,8.46s-7,3.47-8.69,1.56-.59-5.7,2.5-8.47S53.17,66,54.88,67.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-2",
    "data-name": "ACTIVE",
    d: "M54.87,68c1.71,1.9.59,5.7-2.49,8.46s-7,3.47-8.7,1.56-.59-5.7,2.5-8.47S53.16,66.1,54.87,68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,76.49C49.33,79.3,45.36,80,43.6,78S43,72.21,46.11,69.4s7.11-3.5,8.86-1.54S55.6,73.69,52.46,76.49Zm-6.19-6.91c-3,2.72-4.15,6.44-2.49,8.3S49.27,79,52.3,76.32s4.16-6.45,2.49-8.3S49.31,66.86,46.27,69.58Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,68.79c1.28,1.44.33,4.39-2.14,6.6s-5.51,2.84-6.8,1.4-.33-4.39,2.14-6.6S52.33,67.35,53.62,68.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.56,75.48c-2.51,2.25-5.64,2.88-7,1.39s-.36-4.52,2.15-6.77,5.64-2.87,7-1.39S54.07,73.23,51.56,75.48Zm-4.66-5.2c-2.42,2.16-3.37,5-2.13,6.43s4.21.76,6.63-1.41,3.37-5,2.13-6.43S49.31,68.12,46.9,70.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.82,70.19c-2.47,2.21-3.43,5.17-2.14,6.6a2.5,2.5,0,0,0,.39.34c-.81-1.54.18-4.17,2.43-6.18s5-2.71,6.4-1.73a2.12,2.12,0,0,0-.28-.43C52.33,67.35,49.29,68,46.82,70.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,69.45l-.18-.13c-1.41-1-4.1-.22-6.26,1.72s-3.19,4.52-2.4,6l.13.24-.3-.08a1.92,1.92,0,0,1-.42-.36c-1.33-1.48-.36-4.52,2.15-6.77s5.64-2.87,7-1.39a2.5,2.5,0,0,1,.3.45Zm-7.12.83c-2.42,2.16-3.37,5-2.13,6.43v0c-.48-1.64.56-4,2.64-5.87s4.55-2.63,6.12-2v0C52.29,67.49,49.31,68.12,46.9,70.28Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.13 70.92 46.79 71.65 45.75 73 45 74.63 44.81 76.19 45.07 77.13 44.44 76.52 44.12 75.41 44.23 74.18 44.84 72.64 45.92 71.11 46.13 70.92",
    style: {
      fill: "#191410"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7,72a1.12,1.12,0,0,0-.18-.76h0l-.45-.5-.46.16-.38.06a3,3,0,0,0-1.27.63,5.39,5.39,0,0,0-1.17,1.55l-1.7.39a1.77,1.77,0,0,1,.85-.67l.2-1-.42-.46-.55,1h0l-.25.21a3.47,3.47,0,0,0-.8,1.18l-.22.05v-.09l-.19-.22L45.1,74l.65.72.06-.33.14,0a1.53,1.53,0,0,0-.05.41l-.24.1.48.53a1.11,1.11,0,0,0,1.06.17,3,3,0,0,0,1.32-.66,4.85,4.85,0,0,0,1.12-1.38l1.82-.41a2.54,2.54,0,0,1-.49.5,3,3,0,0,1-.42.26l-.06-.13-.84.88.41.46a4.32,4.32,0,0,0,1.51-.89,3.63,3.63,0,0,0,.94-1.32l.79-.18.19-.61-.41-.46ZM48,74.26a1.2,1.2,0,0,1-.47.23.5.5,0,0,1-.41,0,.4.4,0,0,1-.18-.33l1.51-.34A2.09,2.09,0,0,1,48,74.26Zm3.77-1.8-1.7.38a2,2,0,0,1,.5-.62,1.2,1.2,0,0,1,.55-.28.57.57,0,0,1,.51.07A.46.46,0,0,1,51.72,72.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,72.78l-.8.18a3.84,3.84,0,0,1-.93,1.3,4.64,4.64,0,0,1-1.55.91l-.08,0-.54-.61,1-1.07.08.17a2.43,2.43,0,0,0,.29-.2l.24-.21-1.41.32A5,5,0,0,1,48.6,75a3.46,3.46,0,0,1-1.37.68,1.21,1.21,0,0,1-1.17-.2l-.5-.55.07-.18-.7-.78.83-.66.29.32a3.71,3.71,0,0,1,.81-1.17l.22-.18.63-1.14.56.63-.21,1.17-.06,0a1.89,1.89,0,0,0-.58.36l1.3-.29a5.47,5.47,0,0,1,1.17-1.54,3.11,3.11,0,0,1,1.32-.66,1.73,1.73,0,0,1,.38,0l.53-.19.5.56.08.15a1.23,1.23,0,0,1,.12.41l.27-.27.54.61Zm-1,0,.79-.18.15-.48-.28-.32-.51.5,0-.31a1,1,0,0,0-.17-.67l-.1-.14-.27-.3-.43.14-.36.06a3,3,0,0,0-1.22.6,5.51,5.51,0,0,0-1.13,1.52l0,0-2.05.46.17-.25a1.93,1.93,0,0,1,.85-.69l.17-.92-.26-.29-.41.73.07,0-.16.13-.23.2a3.3,3.3,0,0,0-.78,1.14l0,.06-.45.1,0-.21-.08-.09-.35.41.3.4,0-.17.39-.09,0,.18a2.45,2.45,0,0,0,0,.39v.08l-.17.07.37.4a1,1,0,0,0,1,.14,3.32,3.32,0,0,0,1.27-.64,4.94,4.94,0,0,0,1.09-1.35l0,0,2.19-.49-.19.26a2.55,2.55,0,0,1-.52.52,2.23,2.23,0,0,1-.44.28l-.11.05,0-.08-.63.67.28.32a4.07,4.07,0,0,0,1.39-.84,3.67,3.67,0,0,0,.91-1.27Zm-.59-.19-2,.46.14-.24a2.41,2.41,0,0,1,.52-.66,1.54,1.54,0,0,1,.6-.3.68.68,0,0,1,.61.09.58.58,0,0,1,.19.56Zm-1.55.1,1.32-.3a.29.29,0,0,0-.1-.26.46.46,0,0,0-.4,0,1.24,1.24,0,0,0-.51.26A1.8,1.8,0,0,0,50.28,72.66Zm-2.14,1.6-.12.1h0a1.34,1.34,0,0,1-.51.25.72.72,0,0,1-.51-.06.5.5,0,0,1-.23-.43V74l1.9-.43-.17.25A1.89,1.89,0,0,1,48.14,74.26Zm-.26-.1A1.86,1.86,0,0,0,48.1,74L47,74.21a.22.22,0,0,0,.1.14.42.42,0,0,0,.32,0,1.35,1.35,0,0,0,.43-.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.05,72.59,49.23,73a4.9,4.9,0,0,1-1.12,1.39,3.29,3.29,0,0,1-1.32.66,1.13,1.13,0,0,1-1.06-.17,1.07,1.07,0,0,1-.2-1l-.43.1.19-.62.44-.09a3.29,3.29,0,0,1,.8-1.18,3.57,3.57,0,0,1,1.2-.75l-.19,1a1.84,1.84,0,0,0-.85.67l1.7-.38a5.61,5.61,0,0,1,1.17-1.56,2.91,2.91,0,0,1,1.27-.62A1.29,1.29,0,0,1,52,70.6a1.19,1.19,0,0,1,.26,1.15l.81-.19-.19.62-.79.18a3.94,3.94,0,0,1-.94,1.32,4.39,4.39,0,0,1-1.51.88l.23-1.08a3.07,3.07,0,0,0,.68-.39A2.55,2.55,0,0,0,51.05,72.59Zm-4.57,1a.41.41,0,0,0,.17.33.53.53,0,0,0,.42,0,1.36,1.36,0,0,0,.47-.23,2.38,2.38,0,0,0,.45-.49ZM51.31,72a.48.48,0,0,0-.15-.45.58.58,0,0,0-.5-.07,1.35,1.35,0,0,0-.56.28,2.16,2.16,0,0,0-.49.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-3",
    "data-name": "ACTIVE",
    d: "M51.11,72.54,49.29,73a4.76,4.76,0,0,1-1.12,1.39,3.29,3.29,0,0,1-1.32.66,1.24,1.24,0,0,1-1.12-.12,1.14,1.14,0,0,1-.13-1.09l-.36.11.12-.63.43-.1a3.38,3.38,0,0,1,.8-1.18,3.33,3.33,0,0,1,1.17-.64l-.16.94a1.81,1.81,0,0,0-.85.66l1.7-.38A5.39,5.39,0,0,1,49.62,71a2.82,2.82,0,0,1,1.27-.63,1.29,1.29,0,0,1,1.18.16,1.19,1.19,0,0,1,.26,1.15l.78-.1-.16.53-.79.18a3.94,3.94,0,0,1-.94,1.32,4.51,4.51,0,0,1-1.57.93l.29-1.13a3.07,3.07,0,0,0,.68-.39A2.3,2.3,0,0,0,51.11,72.54Zm-4.57,1a.37.37,0,0,0,.18.33.5.5,0,0,0,.41,0,1.36,1.36,0,0,0,.47-.23,2,2,0,0,0,.45-.49Zm4.83-1.66a.48.48,0,0,0-.14-.45.6.6,0,0,0-.51-.07,1.44,1.44,0,0,0-.55.28,2.07,2.07,0,0,0-.5.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,72.28l-.8.18a4,4,0,0,1-.94,1.31,4.37,4.37,0,0,1-1.55.9l-.07,0-.13-.14.12-.37.16-.8.06,0a2.44,2.44,0,0,0,.65-.37l.24-.21-1.41.32a5.12,5.12,0,0,1-1.12,1.37,3.21,3.21,0,0,1-1.37.68,1.21,1.21,0,0,1-1.17-.2,1.06,1.06,0,0,1-.27-1l-.45.1.27-.88.44-.1A3.56,3.56,0,0,1,46.45,72a3.92,3.92,0,0,1,1.26-.86h0l.15.17-.21,1.16-.06,0a1.5,1.5,0,0,0-.58.36l1.3-.3A5.78,5.78,0,0,1,49.48,71a3.15,3.15,0,0,1,1.32-.65,1.42,1.42,0,0,1,1.29.19,1.2,1.2,0,0,1,.32,1.08l.68-.2.13.14Zm-1,0,.78-.17.13-.41-.8.23,0-.17a1.08,1.08,0,0,0-.22-1,1.2,1.2,0,0,0-1.08-.14,2.87,2.87,0,0,0-1.22.61,5.56,5.56,0,0,0-1.14,1.52l0,0-2,.47.17-.26a1.91,1.91,0,0,1,.85-.68l.15-.83a3.75,3.75,0,0,0-1,.7,3.36,3.36,0,0,0-.78,1.14l0,.06-.42.1-.11.35.41-.1,0,.19a1,1,0,0,0,.16.93,1,1,0,0,0,.95.14A3,3,0,0,0,48,74.3a4.65,4.65,0,0,0,1.09-1.36l0,0,2.19-.49-.19.25a2.33,2.33,0,0,1-.52.52,2.88,2.88,0,0,1-.65.39l-.17.8a4,4,0,0,0,1.27-.78A3.61,3.61,0,0,0,52,72.31Zm-.6-.19-2,.46.13-.24a2.4,2.4,0,0,1,.53-.65,1.44,1.44,0,0,1,.6-.31.72.72,0,0,1,.61.1.56.56,0,0,1,.18.56Zm-1.55.1,1.33-.29a.3.3,0,0,0-.1-.26.45.45,0,0,0-.41,0,1.24,1.24,0,0,0-.5.25A2.22,2.22,0,0,0,49.86,72.16Zm-2.13,1.61-.12.09a1.27,1.27,0,0,1-.51.25.63.63,0,0,1-.51-.06.49.49,0,0,1-.23-.43v-.1l1.9-.42-.17.25A3,3,0,0,1,47.73,73.77Zm-1.11-.06a.2.2,0,0,0,.1.14.42.42,0,0,0,.32,0,1.14,1.14,0,0,0,.43-.21,1.94,1.94,0,0,0,.21-.2Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.99 75.82 54.06 77.01 55.19 75.6 56.13 74.08 56.7 72.05 56.6 70.31 56.21 69.42 55.36 68.51 55.8 70.25 55.31 72.22 54.05 74.58 52.99 75.82",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.2 76.59 53.24 77.76 52.66 78.2 51.56 76.98 52.2 76.59",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.69,60.56c.23-2.06-1.23-4.73-3.85-6.67s-5.61-2.54-7.51-1.72L41,51.9,40,53.16c-1.52,2.06,0,5.73,3.28,8.2s7.28,2.79,8.8.73l.93-1.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25,61.46c-3.38-2.5-4.87-6.26-3.31-8.37l1-1.35.41.29c2-.82,5-.12,7.56,1.77s4.11,4.56,3.91,6.71l.4.29-1,1.36C50.66,64.27,46.63,64,43.25,61.46ZM41,52.07l-.85,1.16c-1.49,2,0,5.61,3.25,8S50.54,64,52,62l.86-1.16-.32-.24v-.07c.23-2.07-1.3-4.71-3.8-6.56s-5.48-2.54-7.39-1.71l-.07,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.05,60.83c-1.52,2.06-5.46,1.74-8.8-.73S39.45,54,41,51.9s5.46-1.73,8.8.73S54.57,58.77,53.05,60.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-4",
    "data-name": "ACTIVE",
    d: "M53.05,60.85c-1.52,2.06-5.46,1.74-8.8-.73S39.45,54,41,51.93s5.46-1.74,8.8.73S54.57,58.79,53.05,60.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.18,60.2c-3.38-2.5-4.87-6.26-3.31-8.37s5.59-1.79,9,.71,4.87,6.25,3.31,8.36S47.56,62.7,44.18,60.2Zm5.52-7.47C46.42,50.31,42.55,50,41.07,52s0,5.6,3.25,8,7.15,2.76,8.63.76S53,55.15,49.7,52.73Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,59.76c-1.15,1.55-4.24,1.22-6.9-.75s-3.9-4.82-2.75-6.38,4.23-1.21,6.9.76S53.1,58.21,52,59.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,59.1c-2.72-2-4-4.93-2.78-6.54s4.36-1.27,7.07.73,4,4.94,2.77,6.54S47.7,61.11,45,59.1Zm4.15-5.61c-2.61-1.93-5.63-2.28-6.73-.78s.11,4.28,2.72,6.2,5.63,2.28,6.73.78S51.74,55.41,49.14,53.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.21,53.39c-2.67-2-5.75-2.31-6.9-.75a2.17,2.17,0,0,0-.25.45c1.35-1.11,4.12-.67,6.54,1.12s3.66,4.31,3,5.92a2.1,2.1,0,0,0,.36-.37C53.1,58.21,51.87,55.36,49.21,53.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.39,60.29l.1-.21c.64-1.57-.63-4-3-5.78s-5.08-2.2-6.39-1.12l-.21.17L42,53a3,3,0,0,1,.26-.48c1.19-1.6,4.36-1.27,7.07.73s4,4.94,2.77,6.54a1.68,1.68,0,0,1-.37.39Zm-2.25-6.8c-2.61-1.93-5.63-2.28-6.73-.78h0c1.51-.8,4-.26,6.29,1.39s3.49,3.92,3.17,5.6v0C53,58.2,51.74,55.41,49.14,53.49Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.36 52.86 47.77 53.66 46.24 52.92 44.5 52.51 42.92 52.64 42.06 53.09 42.53 52.34 43.55 51.81 44.78 51.66 46.41 51.95 48.13 52.69 48.36 52.86",
    style: {
      fill: "#191410"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.66,59.51a1.08,1.08,0,0,0,.7-.33h0l.4-.54-.26-.42a1.74,1.74,0,0,0-.13-.36,3.06,3.06,0,0,0-.87-1.12,5.79,5.79,0,0,0-1.76-.83L46,54.34a1.74,1.74,0,0,1,.82.7l1.06,0,.37-.49-1.08-.34h0l-.26-.2a3.37,3.37,0,0,0-1.32-.55l-.09-.21h.09L45.8,53l-.63-.53-.58.79h.33l.06.12a1.7,1.7,0,0,0-.41.05c-.09-.12-.15-.22-.15-.22l-.42.58a1.08,1.08,0,0,0,0,1.07A3.05,3.05,0,0,0,45,56a4.79,4.79,0,0,0,1.58.81l.77,1.71a2.68,2.68,0,0,1-.58-.39,3,3,0,0,1-.35-.36l.11-.08-1-.64-.37.5a4.31,4.31,0,0,0,1.17,1.29,3.81,3.81,0,0,0,1.49.65l.33.74.64.06.37-.49Zm-3.21-4.19a1.31,1.31,0,0,1-.32-.41.58.58,0,0,1,0-.42.39.39,0,0,1,.29-.23L46,55.67A2,2,0,0,1,45.45,55.32ZM48,58.65l-.72-1.59a2.24,2.24,0,0,1,.71.36,1.29,1.29,0,0,1,.39.49.58.58,0,0,1,0,.51A.47.47,0,0,1,48,58.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,60.35l-.34-.74A4.06,4.06,0,0,1,46.2,59,4.56,4.56,0,0,1,45,57.62l0-.07.48-.65,1.26.79-.15.11.25.25c.09.07.17.14.25.19l-.59-1.32a5,5,0,0,1-1.58-.82,3.26,3.26,0,0,1-.94-1.2,1.23,1.23,0,0,1,0-1.19l.43-.59.19,0,.62-.84L46,53l-.25.35a3.62,3.62,0,0,1,1.3.56l.23.17,1.24.39-.5.68-1.19,0,0-.06a1.8,1.8,0,0,0-.46-.49l.55,1.22a5.32,5.32,0,0,1,1.74.83,3,3,0,0,1,.91,1.16,1.74,1.74,0,0,1,.13.36l.29.48-.44.6-.13.11a1.37,1.37,0,0,1-.38.2l.31.21-.48.65Zm-.17-1,.33.73.51,0,.25-.34-.59-.4.3,0a1,1,0,0,0,.63-.3l.11-.13.24-.33-.22-.38a2.37,2.37,0,0,0-.13-.34,2.82,2.82,0,0,0-.84-1.07A5.31,5.31,0,0,0,46.71,56l-.05,0-.87-1.91.29.11a2,2,0,0,1,.84.7l.93,0,.23-.32-.79-.25v.07l-.16-.12-.25-.19a3.44,3.44,0,0,0-1.27-.54h-.06l-.19-.42h.21l.07-.09-.47-.26-.33.37H45l.17.37H45a2.72,2.72,0,0,0-.39,0l-.07,0-.1-.14-.33.44a1,1,0,0,0,.07.95A3.1,3.1,0,0,0,45,55.92a4.79,4.79,0,0,0,1.55.79l.05,0,.92,2-.29-.13a2.61,2.61,0,0,1-.61-.41,2.55,2.55,0,0,1-.36-.37l-.08-.1.07,0-.78-.49-.25.34a4.1,4.1,0,0,0,1.09,1.2,3.69,3.69,0,0,0,1.44.62Zm.07-.63L47,56.86l.26.09a2.39,2.39,0,0,1,.75.38,1.41,1.41,0,0,1,.42.53.66.66,0,0,1,0,.61.57.57,0,0,1-.51.3Zm-.42-1.49.56,1.24a.34.34,0,0,0,.24-.16.45.45,0,0,0,0-.4,1.23,1.23,0,0,0-.35-.45A2.22,2.22,0,0,0,47.49,57.28Zm-2-1.77-.12-.1h0A1.31,1.31,0,0,1,45,55a.66.66,0,0,1,0-.51.5.5,0,0,1,.37-.31l.1,0,.8,1.77L46,55.78A2.73,2.73,0,0,1,45.49,55.51Zm0-.28a1.5,1.5,0,0,0,.24.18l-.45-1a.24.24,0,0,0-.12.13.42.42,0,0,0,0,.32,1.21,1.21,0,0,0,.29.37Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.68,58l-.77-1.7a4.6,4.6,0,0,1-1.58-.82,3.18,3.18,0,0,1-.92-1.16,1.14,1.14,0,0,1,0-1.07,1.06,1.06,0,0,1,1-.4l-.18-.41.64.07.18.4a3.52,3.52,0,0,1,1.32.55,3.42,3.42,0,0,1,1,1l-1.06,0a1.78,1.78,0,0,0-.82-.7l.72,1.59a5.29,5.29,0,0,1,1.75.83,2.88,2.88,0,0,1,.88,1.11,1.3,1.3,0,0,1,.07,1.19,1.15,1.15,0,0,1-1.06.49l.34.76-.64-.07L48.12,59a3.92,3.92,0,0,1-1.48-.65,4.48,4.48,0,0,1-1.17-1.3h1.1a2.93,2.93,0,0,0,.52.59A2.66,2.66,0,0,0,47.68,58Zm-1.93-4.27a.38.38,0,0,0-.29.24.5.5,0,0,0,0,.41,1.12,1.12,0,0,0,.32.42,2.2,2.2,0,0,0,.57.34Zm2.6,4.39a.47.47,0,0,0,.41-.23.58.58,0,0,0,0-.51,1.36,1.36,0,0,0-.39-.49,2,2,0,0,0-.71-.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "ACTIVE-5",
    "data-name": "ACTIVE",
    d: "M47.61,58.06l-.77-1.7a5,5,0,0,1-1.58-.81,3.23,3.23,0,0,1-.91-1.16,1,1,0,0,1,0-1,1,1,0,0,1,.91-.47l0-.32.44,0,.18.4a3.41,3.41,0,0,1,1.32.56,3.13,3.13,0,0,1,.86,1l-.94,0a1.89,1.89,0,0,0-.83-.71l.72,1.59a5.56,5.56,0,0,1,1.76.83,3.06,3.06,0,0,1,.87,1.12,1.31,1.31,0,0,1,.08,1.19,1.18,1.18,0,0,1-1.07.48l.25.75-.55,0L48.06,59a3.81,3.81,0,0,1-1.49-.65,3.53,3.53,0,0,1-1.06-1.19l1-.11a2.43,2.43,0,0,0,.52.59A2.3,2.3,0,0,0,47.61,58.06ZM45.68,53.8a.37.37,0,0,0-.29.23.58.58,0,0,0,0,.42,1.31,1.31,0,0,0,.32.41,1.76,1.76,0,0,0,.57.34Zm2.6,4.38a.45.45,0,0,0,.41-.22.55.55,0,0,0,0-.51,1.21,1.21,0,0,0-.39-.49,2.24,2.24,0,0,0-.71-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.38,59.86,48,59.11a3.88,3.88,0,0,1-1.47-.65,4.47,4.47,0,0,1-1.2-1.34l0-.07.12-.15.39,0h.81l0,.05a2.67,2.67,0,0,0,.5.56,2.19,2.19,0,0,0,.25.2l-.6-1.33a5,5,0,0,1-1.57-.81,3.43,3.43,0,0,1-1-1.21,1.24,1.24,0,0,1,0-1.18,1.06,1.06,0,0,1,.9-.46L45,52.34l.92.09.18.41a3.65,3.65,0,0,1,1.31.55,4.26,4.26,0,0,1,1.1,1.06h0l-.14.19-1.18,0,0,0a1.7,1.7,0,0,0-.47-.49l.55,1.21a5.39,5.39,0,0,1,1.75.83,3.2,3.2,0,0,1,.91,1.16,1.44,1.44,0,0,1,.07,1.3,1.19,1.19,0,0,1-1,.54l.33.62-.11.15Zm-.17-1,.33.73.42,0-.39-.74h.18a1.06,1.06,0,0,0,1-.43,1.21,1.21,0,0,0-.08-1.08,2.82,2.82,0,0,0-.84-1.07,5.53,5.53,0,0,0-1.72-.81h0l-.87-1.92.28.12a1.87,1.87,0,0,1,.84.69l.85,0a3.61,3.61,0,0,0-.89-.81A3.27,3.27,0,0,0,46,53.06h-.06l-.18-.4-.37,0,.17.39h-.18a.94.94,0,0,0-.88.34,1,1,0,0,0,.05,1,3.13,3.13,0,0,0,.88,1.12,4.79,4.79,0,0,0,1.55.79l0,0,.92,2-.29-.13a2.78,2.78,0,0,1-1.12-1h-.82a4.07,4.07,0,0,0,1,1.08,3.87,3.87,0,0,0,1.44.63Zm.06-.62-.86-1.91.26.08a2.39,2.39,0,0,1,.75.38,1.49,1.49,0,0,1,.42.53.69.69,0,0,1,0,.62.58.58,0,0,1-.51.29Zm-.41-1.5L48.42,58a.28.28,0,0,0,.23-.15.44.44,0,0,0,0-.41,1.2,1.2,0,0,0-.35-.44A1.77,1.77,0,0,0,47.86,56.78Zm-2-1.77-.12-.09a1.44,1.44,0,0,1-.35-.46.6.6,0,0,1,0-.5.47.47,0,0,1,.37-.31l.1,0,.8,1.78-.28-.12A2.73,2.73,0,0,1,45.86,55Zm-.18-1.1a.21.21,0,0,0-.11.13.42.42,0,0,0,0,.32,1,1,0,0,0,.29.38,1.46,1.46,0,0,0,.24.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.95 60.58 44 61.86 45.61 62.68 47.29 63.3 49.39 63.45 51.08 63 51.87 62.44 52.58 61.42 50.97 62.2 48.94 62.12 46.38 61.36 44.95 60.58",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.03 59.95 43.1 61.21 42.55 60.73 43.52 59.41 44.03 59.95",
    style: {
      fill: "#16110d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,33.06.5,60.76l48,27.7,48-27.7Zm48,27.7-48,27.7v55.41l48-27.7Zm-48,27.7L.5,60.76v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Change"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.88 0 152.87 27.7 152.87 83.11 104.89 110.81 56.9 83.11 56.9 27.7 104.88 0",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9,83.57l48-27.82m0,0L104.78.34m.15,55.41,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,48.79l-6.47-4a3.53,3.53,0,0,0-.57-.38l-.36-.2h0c-2.87-1.5-6.75-1.2-11,1.27-8.85,5.11-16,17.54-16,27.75,0,5.08,1.77,8.65,4.63,10.34h0l6.85,4.26,1.43-3.16.57-1a17.84,17.84,0,0,0,2.54-1.23c8.85-5.11,16-17.53,16-27.75,0-.61,0-1.2-.08-1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.36,88.46,91,83.88c-3.07-1.87-4.76-5.65-4.76-10.66,0-10.34,7.29-22.95,16.24-28.12,4.11-2.38,8.05-2.89,11.13-1.45h0l.69.37a2.81,2.81,0,0,1,.45.28l.17.13,6.81,4.22-2.65,4.41c.05.55.07,1.11.07,1.67,0,10.34-7.29,23-16.24,28.13a20,20,0,0,1-2.46,1.21l-.5.82Zm-6.6-5.14L98,87.19l1.22-2.71.67-1.13.14,0a17.67,17.67,0,0,0,2.48-1.21c8.72-5,15.81-17.31,15.81-27.37,0-.58,0-1.17-.08-1.74v-.14l2.35-3.91L114.24,45a1.92,1.92,0,0,0-.33-.21l-.37-.2c-2.85-1.48-6.62-1-10.61,1.27-8.71,5-15.8,17.31-15.8,27.37,0,4.74,1.57,8.28,4.42,10Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.86,
    cy: 68.43,
    rx: 22.66,
    ry: 13.08,
    transform: "translate(-4.33 129.35) rotate(-60)",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,89.56a8.72,8.72,0,0,1-4.39-1.13c-3.17-1.83-4.91-5.65-4.91-10.75,0-10.34,7.29-23,16.24-28.13,4.42-2.55,8.6-2.95,11.76-1.12s4.92,5.64,4.92,10.75c0,10.34-7.29,22.95-16.24,28.12A15,15,0,0,1,102.7,89.56ZM117,48.17a14.08,14.08,0,0,0-6.93,2.14c-8.72,5-15.81,17.3-15.81,27.37,0,4.77,1.59,8.32,4.48,10s6.75,1.27,10.89-1.12c8.71-5,15.8-17.31,15.8-27.37,0-4.78-1.59-8.33-4.47-10A7.88,7.88,0,0,0,117,48.17Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ACTIVE-6",
    "data-name": "ACTIVE",
    cx: 109.92,
    cy: 68.54,
    rx: 19.55,
    ry: 11.23,
    transform: "translate(-4.88 128.54) rotate(-59.54)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.47,69.11l5.81-10.45c.16-.29.45-.25.36.06l-4.31,10.76Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,69.86,108,69.34l6-10.84a.59.59,0,0,1,.72-.33.49.49,0,0,1,.24.64Zm-1.57-1,1.16.23,3.29-8.22Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,67.15a4.8,4.8,0,0,1-2.16,3.75c-1.2.68-2.17.13-2.17-1.25a4.78,4.78,0,0,1,2.17-3.75C111.07,65.21,112,65.77,112,67.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.92,
    cy: 68.48,
    rx: 3.06,
    ry: 1.77,
    transform: "translate(-4.34 129.44) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.91,71.52a1.36,1.36,0,0,1-.72-.19,1.81,1.81,0,0,1-.8-1.68,5.07,5.07,0,0,1,2.32-4,1.64,1.64,0,0,1,2.66,1.53,5.05,5.05,0,0,1-2.33,4A2.25,2.25,0,0,1,108.91,71.52Zm1.93-5.59a1.71,1.71,0,0,0-.8.25,4.44,4.44,0,0,0-2,3.47,1,1,0,0,0,1.67,1,4.4,4.4,0,0,0,2-3.46,1.21,1.21,0,0,0-.47-1.12A.74.74,0,0,0,110.84,65.93Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,57.78l-.06,0c-.21.13-.38,0-.38-.29V55.17a.92.92,0,0,1,.38-.73l.06,0c.21-.12.38,0,.38.29v2.36A.92.92,0,0,1,109.91,57.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.25,56.79h0c-.21.06-.34-.13-.29-.42l.55-2.66a.85.85,0,0,1,.5-.62h0c.22-.06.35.12.29.41l-.54,2.66A.86.86,0,0,1,112.25,56.79Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.47,56.57h0c-.2,0-.27-.27-.15-.56l1.05-2.71c.11-.3.36-.52.56-.5h0c.2,0,.26.27.15.56l-1,2.71C114.91,56.36,114.66,56.58,114.47,56.57Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,57.15h0c-.16-.09-.16-.39,0-.67l1.49-2.57c.16-.28.42-.43.58-.34h0c.16.1.16.4,0,.67L117,56.82C116.79,57.1,116.53,57.25,116.37,57.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,58.51h0a.71.71,0,0,1,.15-.74l1.82-2.26c.2-.25.45-.31.56-.15h0a.69.69,0,0,1-.15.73l-1.82,2.27C118.19,58.6,117.94,58.67,117.83,58.51Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,60.53h0a.83.83,0,0,1,.29-.74l2-1.81c.22-.19.44-.17.5.05h0a.85.85,0,0,1-.29.75l-2,1.8C119,60.77,118.8,60.75,118.75,60.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,63.1h0a.86.86,0,0,1,.35-.68l2.22-1.28c.19-.11.35,0,.35.27h0a.88.88,0,0,1-.35.68l-2.22,1.28C119.22,63.48,119.06,63.36,119.06,63.1Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.75,66h0a.83.83,0,0,1,.5-.62l2-.55c.22-.06.35.13.29.41h0a.85.85,0,0,1-.5.63l-2,.54C118.82,66.49,118.69,66.31,118.75,66Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.83,69.11h0c.11-.29.36-.52.56-.5l1.82.16c.2,0,.26.27.15.56h0c-.11.3-.36.52-.56.5L118,69.67C117.78,69.65,117.72,69.4,117.83,69.11Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93,78.29h0a.71.71,0,0,1-.15.73L100,81.29c-.2.24-.45.31-.57.15h0a.71.71,0,0,1,.16-.74l1.82-2.26C101.56,78.19,101.81,78.13,101.93,78.29Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,76.26h0a.85.85,0,0,1-.29.75l-2,1.8c-.22.19-.45.17-.5,0h0a.84.84,0,0,1,.29-.75l2-1.8C100.73,76,101,76,101,76.26Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.7,73.7h0a.86.86,0,0,1-.36.68l-2.21,1.27c-.2.12-.36,0-.36-.26h0a.83.83,0,0,1,.36-.68l2.21-1.28C100.54,73.32,100.7,73.44,100.7,73.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,70.77h0a.85.85,0,0,1-.5.63l-2,.54c-.22.06-.35-.12-.29-.41h0a.8.8,0,0,1,.5-.62l2-.55C100.94,70.3,101.07,70.49,101,70.77Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93,67.69h0c-.12.29-.37.51-.56.49L99.55,68c-.2,0-.27-.27-.16-.56h0c.12-.29.37-.51.57-.5l1.82.17C102,67.14,102,67.4,101.93,67.69Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.39,64.65h0c-.16.28-.42.43-.58.33l-1.49-.85c-.16-.1-.16-.4,0-.67h0c.16-.28.42-.43.58-.34l1.49.86C103.55,64.07,103.55,64.37,103.39,64.65Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.29,61.87h0c-.2.24-.45.31-.56.15l-1-1.5a.67.67,0,0,1,.15-.73h0c.19-.25.44-.31.56-.15l1,1.49A.72.72,0,0,1,105.29,61.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,59.53h0c-.22.19-.44.17-.5,0l-.55-2a.88.88,0,0,1,.29-.74h0c.22-.2.45-.18.51,0l.54,2A.84.84,0,0,1,107.5,59.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.91,57.78l-.06,0c-.21.13-.38,0-.38-.29V55.17a.92.92,0,0,1,.38-.73l.06,0c.21-.12.38,0,.38.29v2.36A.92.92,0,0,1,109.91,57.78Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.28,76.67l-8.94,5.16c-.47.27-.85,0-.85-.64v-1a2,2,0,0,1,.85-1.62l8.94-5.16c.47-.28.86,0,.86.64v1A2,2,0,0,1,114.28,76.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,82.68a.8.8,0,0,1-.38-.1,1.07,1.07,0,0,1-.46-1v-1a2.39,2.39,0,0,1,1-1.91l8.94-5.16a.87.87,0,0,1,.89,0,1.06,1.06,0,0,1,.46,1v1a2.37,2.37,0,0,1-1,1.91l-8.94,5.16A1,1,0,0,1,105.07,82.68ZM114.68,74a.43.43,0,0,0-.17.06l-8.94,5.16a1.75,1.75,0,0,0-.69,1.34v1a.51.51,0,0,0,.13.4c.08,0,.19,0,.23,0l8.94-5.17a1.71,1.71,0,0,0,.69-1.34v-1c0-.23-.06-.37-.13-.41Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.34,44l1.81-2.14a.19.19,0,0,0,0-.31L108.65,39l-.05,0,.05,0-.13-.06A1.55,1.55,0,0,0,107,39l-6.71,4a3.14,3.14,0,0,0-1.53,2.7v4.13l4.52,2.56,5.47-7.2,1-.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,53l-5.07-2.86V45.75a3.59,3.59,0,0,1,1.73-3.07l6.71-4a2,2,0,0,1,1.91-.09l.09.05h0l4.54,2.58a.6.6,0,0,1,.31.47.62.62,0,0,1-.21.53l-1.85,2.21-1.64.43-.85.73Zm-4.2-3.37,4,2.24,5.29-7,1-.9,1.57-.4,1.54-1.83-4.31-2.44a1.1,1.1,0,0,0-1.07,0l-6.72,4a2.7,2.7,0,0,0-1.31,2.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69,41.65l-6.71,4a3.16,3.16,0,0,0-1.51,2.48v4.34a26,26,0,0,1,5.32-4.2,16.15,16.15,0,0,1,5.3-2.17V43A1.59,1.59,0,0,0,111.69,41.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.52,53.08l-.49-.3V48.17a3.6,3.6,0,0,1,1.72-2.85l6.72-4A2,2,0,0,1,114.53,43v3.51l-.38.06A15.17,15.17,0,0,0,109,48.69a25.26,25.26,0,0,0-5.22,4.13Zm8.4-11-6.72,4a2.73,2.73,0,0,0-1.3,2.13v3.27a24.78,24.78,0,0,1,4.66-3.53,16.87,16.87,0,0,1,5.08-2.16V43a1.15,1.15,0,0,0-.58-1,1.13,1.13,0,0,0-1.15,0Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.64,86.66a7.39,7.39,0,0,1-3.76-1c-2.68-1.56-4.16-4.81-4.14-9.16,0-8.86,6.36-19.7,14.08-24.16,3.83-2.21,7.43-2.56,10.14-1s4.16,4.81,4.14,9.15c0,8.86-6.35,19.7-14.08,24.16A13,13,0,0,1,103.64,86.66ZM116.2,51.07a12.36,12.36,0,0,0-6,1.87C102.6,57.3,96.43,67.88,96.4,76.54c0,4.1,1.34,7.15,3.81,8.58s5.87,1.1,9.48-1c7.55-4.36,13.72-15,13.76-23.6h0c0-4.1-1.34-7.15-3.82-8.59A6.81,6.81,0,0,0,116.2,51.07Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.38 63.97 95.61 68.19 94.27 72.83 93.85 76.71 94.07 80.58 95.05 83.8 96.07 86.52 89.47 82.03 87.52 78.61 86.74 74.65 86.87 70.35 87.48 67.14 88.38 63.97",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.9 45.33 103.47 48.03 103.47 52.51 98.79 49.75 98.9 45.33",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.6,
    cy: 90.15,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.81,
    cy: 88.87,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.82,88.63a.25.25,0,0,1,0,.48.91.91,0,0,1-.85,0,.25.25,0,0,1,0-.48A.91.91,0,0,1,92.82,88.63Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,87.35a.26.26,0,0,1,0,.49,1,1,0,0,1-.85,0,.26.26,0,0,1,0-.49A1,1,0,0,1,95,87.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.61,87.35a.26.26,0,0,1,0,.49,1,1,0,0,1-.85,0,.26.26,0,0,1,0-.49A1,1,0,0,1,90.61,87.35Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.39,
    cy: 86.32,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.61,84.8c.23.13.23.35,0,.49a1,1,0,0,1-.85,0c-.23-.14-.23-.36,0-.49A.91.91,0,0,1,90.61,84.8Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.74,
    cy: 93.77,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.95,
    cy: 92.49,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.58,91c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,110.58,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.79,89.7c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,112.79,89.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,88.42c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,115,88.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21,87.15c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,117.21,87.15Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119,
    cy: 86.11,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.21,
    cy: 84.84,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74,93.53c.24.13.24.35,0,.48a.89.89,0,0,1-.84,0,.25.25,0,0,1,0-.48A.89.89,0,0,1,101.74,93.53Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,92.25c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A1,1,0,0,1,104,92.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.74,
    cy: 91.22,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.95,
    cy: 89.94,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.58,88.42c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,110.58,88.42Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.37,
    cy: 87.39,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,85.87c.24.14.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,115,85.87Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21,84.59c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,117.21,84.59Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,83.32c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,119.42,83.32Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.63,82c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,121.63,82Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.53,92.25c.24.13.24.35,0,.49a1,1,0,0,1-.84,0,.26.26,0,0,1,0-.49A1,1,0,0,1,99.53,92.25Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74,91c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,101.74,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,89.7c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,104,89.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.79,
    cy: 82.29,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119,
    cy: 81.01,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.21,
    cy: 79.73,
    rx: 0.6,
    ry: 0.35,
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.32,91c.24.14.24.36,0,.49a.89.89,0,0,1-.84,0c-.23-.13-.23-.35,0-.49A1,1,0,0,1,97.32,91Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.53,89.7c.24.13.24.35,0,.49a1,1,0,0,1-.84,0c-.23-.14-.23-.36,0-.49A.89.89,0,0,1,99.53,89.7Z",
    style: {
      fill: "#16110d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.79,85.87c-1.59-1.92-2.45-4.73-2.45-8.22a27.57,27.57,0,0,1,1.44-8.41L95,68.79a28.51,28.51,0,0,0-1.55,8.86,14.85,14.85,0,0,0,1.8,7.59l1.29.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.05.34,57.07,28l48,27.7L153,28ZM153,28l-48,27.7v55.41l48-27.7Zm-48,27.7L57.07,28V83.45l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFgLight1);
export default __webpack_public_path__ + "static/media/ICON_fg_light_1.21a0ec586379873219a4bd641a00770a.svg";
export { ForwardRef as ReactComponent };